/* eslint-disable react/jsx-props-no-spreading */
import {
    GridColumnMenu, GridColumnMenuProps,
} from '@mui/x-data-grid-pro'

function ColumnMenuWithoutFilter(props: Readonly<GridColumnMenuProps>) {
    return (
        <GridColumnMenu
            {...props}
            slots={{
                columnMenuFilterItem: null,
            }}
        />
    )
}

export default ColumnMenuWithoutFilter
